module.exports = __webpack_public_path__ + "static/media/next-icon.f0409567.svg";